import { fetchDataByTag as fetchDataByTagApi } from 'support/api/DataByTagApi';
import { HttpClient } from 'support/api/api-types';

export const SPORT = 'SPORT' as const;
export const CLEAR_SPORT = 'CLEAR_SPORT' as const;

export const fetchSport = (tag: string) => ({
  type: SPORT,
  promise: (httpClient: HttpClient) => fetchDataByTagApi(httpClient, tag),
  meta: {
    id: tag,
  },
});

export const clearSport = () => ({
  type: CLEAR_SPORT,
});
